import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Order } from 'contracts/Orders';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_OLD_ORDERS_',
  }
);

export interface ListOldOrdersState {
  data: Order[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListOldOrdersRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Order[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListOldOrdersState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListOldOrdersState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListOldOrdersState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data }
  });

const failure = (state: ListOldOrdersState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListOldOrdersState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listOldOrders = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListOldOrdersTypes = Types;
export const ListOldOrdersActions = Creators;
